import { useState } from 'react';
import PasswordInput from '../components/PasswordInput.jsx';

const tabs = [
  { id: 'account', label: 'Conta e Assinatura', icon: 'credit_card' },
  { id: 'security', label: 'Segurança e Privacidade', icon: 'shield' },
  { id: 'profile', label: 'Informações Pessoais', icon: 'person' },
];

function Field({ label, value, hint, type = 'text' }) {
  const inputCls =
    'mt-1 w-full bg-surface py-3 px-4 rounded-lg font-body-md text-body-md text-on-surface placeholder:text-on-surface-variant/50 focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all border border-surface-container-high';
  return (
    <div>
      <label className="font-label-sm text-label-sm text-on-surface-variant">{label}</label>
      {type === 'password' ? (
        <PasswordInput defaultValue={value} className={`${inputCls} pr-10`} />
      ) : (
        <input type={type} defaultValue={value} className={inputCls} />
      )}
      {hint && <p className="text-[10px] text-on-surface-variant mt-1">{hint}</p>}
    </div>
  );
}

function Account() {
  return (
    <div className="max-w-xl bg-surface rounded-2xl shadow-sm p-6">
      <p className="text-[11px] text-on-surface-variant">
        As informações de plano, consumo de impressões e notas fiscais serío exibidas aqui quando a gestío de assinatura do tenant estiver disponível.
      </p>
    </div>
  );
}

function Security() {
  return (
    <div className="max-w-xl bg-surface rounded-2xl shadow-sm p-6 flex flex-col gap-4">
      <Field label="Senha atual" value="" hint="Mínimo 8 caracteres." type="password" />
      <Field label="Nova senha" value="" type="password" />
      <div className="flex items-center justify-between rounded-lg bg-surface-container-low px-4 py-3">
        <div>
          <p className="text-[11px] font-semibold text-on-surface">Autenticação em dois fatores (2FA)</p>
          <p className="text-[10px] text-on-surface-variant">Adiciona uma camada extra de segurança ao login.</p>
        </div>
        <span className="inline-flex items-center px-3 py-1 rounded-full bg-surface-variant text-on-surface-variant font-label-sm text-label-sm">
          Em breve
        </span>
      </div>
      <div className="flex items-center justify-between rounded-lg bg-surface-container-low px-4 py-3">
        <div>
          <p className="text-[11px] font-semibold text-on-surface">Sessões ativas</p>
          <p className="text-[10px] text-on-surface-variant">Encerre sessões em outros dispositivos.</p>
        </div>
        <button className="border border-outline-variant text-on-surface font-label-sm text-label-sm px-4 py-2 rounded-lg hover:bg-surface-container-high">
          Revogar
        </button>
      </div>
    </div>
  );
}

function Profile({ user }) {
  return (
    <div className="max-w-xl bg-surface rounded-2xl shadow-sm p-6 flex flex-col gap-4">
      <div className="flex items-center gap-3 pb-2">
        <div className="w-14 h-14 rounded-full bg-primary text-on-primary flex items-center justify-center text-h2 font-bold">
          {(user?.name || 'EA').slice(0, 2).toUpperCase()}
        </div>
        <div>
          <p className="font-semibold text-on-surface">Edição de perfil</p>
          <p className="text-[11px] text-on-surface-variant">Nome e dados de contato.</p>
        </div>
      </div>
      <Field label="Nome completo" value={user?.name || ''} />
      <Field label="E-mail" value={user?.email || ''} />
      <button className="w-fit bg-primary hover:bg-surface-tint text-on-primary font-label-sm text-label-sm px-6 py-3 rounded-lg transition-all shadow-md shadow-primary/20">
        Salvar alterações
      </button>
    </div>
  );
}

export default function Settings({ user }) {
  const [tab, setTab] = useState('account');
  return (
    <div className="flex flex-col gap-base">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 text-on-surface">Configurações</h1>
        <p className="font-body-md text-body-md text-on-surface-variant mt-2">Conta, segurança e dados pessoais do Studio.</p>
      </div>

      <div className="flex gap-2 border-b border-surface-container-highest pb-3">
        {tabs.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg font-label-sm text-label-sm transition-colors ${tab === t.id ? 'bg-primary-container text-on-primary-container' : 'text-on-surface-variant hover:bg-surface-container-high'
              }`}
          >
            <span className="material-symbols-outlined text-[14px]">{t.icon}</span>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'account' && <Account />}
      {tab === 'security' && <Security />}
      {tab === 'profile' && <Profile user={user} />}
    </div>
  );
}


